<!-- Supporting Business Documents -->
@if (order.ultimateBeneficialOwnershipRequest?.documents?.length) {
  <mat-card class="results-content card-margin"
    >
    <div class="table-wrapper">
      <table mat-table [dataSource]="order.ultimateBeneficialOwnershipRequest!.documents" class="docs-table"
        [attr.aria-label]="'common.labels.supportingBusinessDocuments' | transloco">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef scope="col">{{ 'common.labels.document' | transloco }}</th>
          <td mat-cell *matCellDef="let row">
            {{ row.name }} @if (row.isRequired) {
            <span class="required"> *</span>
          }
        </td>
      </ng-container>
      <!-- Type Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef scope="col">{{ 'common.labels.type' | transloco }}</th>
        <td mat-cell *matCellDef="let row">
          {{ row.documentType }}
        </td>
      </ng-container>
      <!-- File Name Column -->
      <ng-container matColumnDef="file-name">
        <th mat-header-cell *matHeaderCellDef scope="col">{{ 'common.labels.fileName' | transloco }}</th>
        <td mat-cell *matCellDef="let row">
          {{ row?.document?.fileName ?? "" }}
        </td>
      </ng-container>
      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef scope="col" class="text-right"></th>
        <td mat-cell *matCellDef="let row" class="text-right">
          <button mat-icon-button color="primary" [disabled]="isDownloading(row.id) || !row?.document?.id"
            (click)="onRowDownload(row.id)" [matTooltip]="'common.buttons.download' | transloco" [attr.aria-label]="'common.labels.downloadDocument' | transloco">
            @if (!isDownloading(row.id)) {
              <mat-icon>download</mat-icon>
            }
            @if (isDownloading(row.id)) {
              <mat-progress-spinner mode="indeterminate" [diameter]="20"
                strokeWidth="3">
              </mat-progress-spinner>
            }
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedDocColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedDocColumns"></tr>
    </table>
  </div>
</mat-card>
} @else {
  <mat-card class="card empty">
    <div class="empty-state">
      <mat-icon>description</mat-icon>
      <span>{{ 'uboSupportingBusinessDocuments.noSupportingDocumentsAreAssociatedWith' | transloco }}</span>
    </div>
  </mat-card>
}

